import storage from '@/utils/storage'
export default {
  state: {
    userInfo:JSON.parse(storage.get('userInfo')),
    token:null
  },
  actions:{
  	setUserInfo ({commit}, userInfo) {
      commit('setUserInfo', userInfo);
   },
   setToken ({commit}, token) {
      commit('setToken', token);
   },
   ['member.outLogin'] ({commit}) {
      commit('member.outLogin');
    },
  },
  mutations:{
  	setUserInfo (state,userInfo) {
      storage.set('userInfo', JSON.stringify(userInfo));
      state.userInfo = userInfo;
   },
   setToken (state,token) {
      storage.set('token',token);
      state.token = token;
   },
   ['member.outLogin'] (state) {
      storage.remove('token');
      storage.remove('userInfo');
      storage.remove('skuType');
      state.userInfo = null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/member/index.js